"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var sketch_devices_component_1 = require("./sketch-devices.component");
var styled_components_1 = __importDefault(require("styled-components"));
var DeviceContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  bottom: 8px;\n  left: 52%;\n  transform: translateX(-50%);\n  z-index: 4;\n"], ["\n  position: absolute;\n  display: flex;\n  bottom: 8px;\n  left: 52%;\n  transform: translateX(-50%);\n  z-index: 4;\n"])));
DeviceContainer.displayName = 'DeviceContainer';
var InstallationSketchDevices = function (props) {
    var devices = props.devices;
    var mixer = devices.find(function (device) { return device.type === 'MIXER'; });
    var pumps = devices.filter(function (device) { return device.type === 'PUMP'; });
    return (react_1.default.createElement(DeviceContainer, __assign({}, props),
        mixer && react_1.default.createElement(sketch_devices_component_1.Mixer, __assign({}, mixer)),
        pumps && pumps.map(function (pump, index) { return react_1.default.createElement(sketch_devices_component_1.Pump, __assign({ key: index }, pump)); })));
};
InstallationSketchDevices.displayName = 'InstallationSketchDevices';
exports.default = InstallationSketchDevices;
var templateObject_1;
